/**
 * Offer data for the Endocrine Exposure Check.
 *
 * THE FUNNEL SELLS ONE PRODUCT: the Natural Body Wash. Nothing here names,
 * routes to or recommends a kit, and no funnel copy may promise a deodorant.
 *
 * NO PRICE IS RENDERED ANYWHERE, by design, so no price lives here. Manly's
 * pricing moves underneath us (site-wide sales, subscription discount, per-region
 * currency). The CTA hands off to Manly's live offer page, which is the source
 * of truth for whatever deal is running; the funnel itself never names one.
 */
export const OFFER = {
  product: {
    name: "Manly Natural Body Wash",
    // Not rendered anywhere on the funnel today (ProductPage.tsx uses only
    // product.name, guarantee.lead/detail and pdpHref). Still guarded as data
    // in funnel.test.tsx's OFFER hygiene block, so a price or kit claim
    // drifting in here would be caught even though nothing displays it.
    copy: "One bottle, in the shower he already takes. Every ingredient printed on the back, because nothing on it needs to hide.",
  },
  guarantee: {
    lead: "Sixty days, any reason.",
    detail: "Not 30. Not 14. Sixty, and we cover return shipping.",
  },
  // Client direction 2026-08-21: hand off to the same GWP offer page the main
  // quiz exits to (was the bare body-wash PDP). The field keeps its name so the
  // hand-off code and its tests are untouched; what changes is the destination.
  pdpHref: "https://usemanly.com/pages/Gwp-mof",
} as const;
